// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  CONFIRM: '[data-role="confirm"]',
  BACK: '[data-role="back-button"]',
  MODAL: '[data-role="modal"]',
  OVERLAY: '[data-role="overlay"]'
};

class Modal extends WebComponent {
  constructor(props) {
    super(props);

    this.handleOpen = this.handleOpen.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.lastActiveElement = null;
    this.urlParamName = 'modal';
    this.returnUrlParamName = 'returnUrl';
    this.focusableSelector =
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
  }

  didMount() {
    if (!this.element) {return;}

    this.confirmButton = this.element.querySelector(fragments.CONFIRM);
    this.backButton = this.element.querySelector(fragments.BACK);
    this.modal = this.element.querySelector(fragments.MODAL);
    this.overlay = this.element.querySelector(fragments.OVERLAY);

    if (this.element.dataset.modalUrlParam) {
      this.urlParamName = this.element.dataset.modalUrlParam;
    }

    const currentUrl = new URL(window.location.href);

    this.confirmUrl = new URL(window.location.href);
    this.confirmUrl.searchParams.delete(this.urlParamName);
    this.confirmUrl.searchParams.delete(this.returnUrlParamName);
    const lang = document.documentElement.lang;

    this.returnUrl = currentUrl.searchParams.get(this.returnUrlParamName) || document.referrer || `/${lang}`;

    if (this.confirmButton) {
      this.confirmButton.addEventListener('click', this.handleConfirm);
    }

    if (this.backButton) {
      this.backButton.addEventListener('click', this.handleBack);
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', this.handleBack);
    }

    document.addEventListener('keydown', this.handleKeyDown);

    if (currentUrl.searchParams.has(this.urlParamName)) {
      this.handleOpen();
    }
  }

  willUnMount() {
    if (this.confirmButton) {
      this.confirmButton.removeEventListener('click', this.handleConfirm);
    }

    if (this.backButton) {
      this.backButton.removeEventListener('click', this.handleBack);
    }

    if (this.overlay) {
      this.overlay.removeEventListener('click', this.handleBack);
    }

    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleOpen() {
    if (!this.modal) {return;}

    this.lastActiveElement = document.activeElement;

    this.modal.hidden = false;
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-open-modal');

    const firstFocusable = this.modal.querySelector(this.focusableSelector);

    if (firstFocusable) {
      firstFocusable.focus();
    }
  }

  hideModal() {
    if (!this.modal) {return;}

    this.modal.hidden = true;
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-open-modal');

    if (this.lastActiveElement && typeof this.lastActiveElement.focus === 'function') {
      this.lastActiveElement.focus();
    }
  }

  handleConfirm(event) {
    if (event) {event.preventDefault();}

    this.hideModal();
    window.history.replaceState({}, '', this.confirmUrl.toString());
  }

  handleBack(event) {
    if (event) {event.preventDefault();}

    if (this.returnUrl) {
      window.location.href = this.returnUrl;
      return;
    }

    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    this.hideModal();
  }

  handleKeyDown(event) {
    if (!this.modal || this.modal.hidden) {return;}

    if (event.key === 'Escape') {
      this.handleBack(event);
      return;
    }

    if (event.key === 'Tab') {
      const focusableElements = Array.from(
        this.modal.querySelectorAll(this.focusableSelector)
      ).filter((element) => {
        if (!(element instanceof HTMLElement)) {return false;}
        return !element.hasAttribute('disabled') && element.offsetParent !== null;
      });

      if (!focusableElements.length) {
        event.preventDefault();
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Modal.js